import React, { useEffect, useRef, useState } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import liracrypt from "../../../Liracrypt/liracrypt";

const Angela1C = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [chartData, setChartData] = useState();

  const getApiChartData = () => {
    liracrypt.get(props.api, props.urlData).then(response => {
      if (!response.data.data[props.divId]) {
        return;
      }
      if (props.setChartId) {
        props.setChartId(response.data.data[props.divId].meta._id);
      }
      if (props.setChartDataSource) {
        props.setChartDataSource(response.data.data[props.divId].meta.autoMan);
      }
      setChartData({ config: response.data.data[props.divId].config });
    }).catch(err => {
      console.log(err);
    })
  }

  useEffect(() => {
    if (props.refreshChart) {
      getApiChartData();
    }
  }, [props.refreshChart])

  useEffect(() => {
    if (props.api) {
      getApiChartData();
    } else if (props.config) {
      setChartData({ config: props.config });
    }
  }, [props?.config]);
  // useEffect(() => {
  //   if (props.config) {
  //   }
  //   return () => {};
  // }, [props?.config]);
  // let  dataBlocks =props.config.dataBlocks;
  // let headerBlocks =props.config.headerBlocks;

  return (
    <>
      {chartData?.config ? (
        <>
          <div id={props.divId} style={{...chartData.config.chartDiv.style}}>

            <Row>
              {chartData.config.headerBlocks.map((headerBlock) => {
                return (

                  <Row style={{ width: "100%" }}>

                    <Col style={{ width: "100%" }}>
                      <div style={headerBlock.val.style}>
                        {`${headerBlock.val.text} `}
                      </div>
                    </Col>
                  </Row>

                );
              })}
            </Row>






            {/* <Row>
              <Col style={{ width: "100%" }} >
                <div style={chartData.config.header.headerText.style}>
                  {`${chartData.config.header.headerText.text} `}
                </div>
              </Col>
            </Row> */}

            <hr style={chartData.config.divider.style}></hr>


            <div>
              {chartData.config.dataBlocks.map((dataBlock) => {
                return (

                  <Row>

                    <Col style={{ width: "100%" }}>
                      <div style={dataBlock.val.style}>
                        {`${dataBlock.val.text} `}
                      </div>
                    </Col>
                  </Row>

                );
              })}
            </div>






          </div>
        </>
      ) : (
        <div className="Loading" style={{padding: 0}}>
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </>
  );
};

export default Angela1C;
